import React, { FC } from 'react'
import classnames from 'classnames/bind'
import { GxIcon } from '@garpix/garpix-web-components-react'
import CalendarIcon from '../../assets/icons/CalendarIcon.svg'
import styles from './style/index.module.scss'
import { ClockIcon } from '../../assets'
import Button from '../Button'

export interface ICalendarInput {
  openCalendar?: React.MouseEventHandler<HTMLDivElement>
  value?: string | number | readonly string[]
  type?: 'full' | 'md' | 'sm' | 'sm_s' | 'sm_l' | 'sm_xl' | 'md_radius' | 'clock'
  time?: boolean
  clear?: () => void
  disabled?: boolean
  handleValueChange?: React.ChangeEventHandler<HTMLInputElement>
  readOnly?: boolean
}

const CalendarInput: FC<ICalendarInput> = (props: any) => {
  const {
    openCalendar,
    value,
    type,
    time,
    clear,
    disabled = false,
    handleValueChange,
    readOnly = true
  } = props;

  const cn = classnames.bind(styles);
  const handleDelete: React.MouseEventHandler<HTMLGxButtonElement> = (e) => {
    if (clear) {
      e.stopPropagation();
      clear();
    }
  };

  const onKeyPress: React.KeyboardEventHandler<HTMLInputElement> = (event) => {
    if (/[^0-9.]/g.test(event.key)) {
      event.preventDefault();
    }
  }

  return (
    <div
      className={cn({
        calendar: true,
      [`calendar--${type}`]: !!type,
      })}
      onClick={openCalendar}
      role='button'
      tabIndex={0}
    >
      <input
        value={value}
        readOnly={readOnly}
        className={cn(
          styles['calendar--input'],
          {
            [styles[`calendar--input_${type}`]]: !!type,
          },
        )}
        onChange={handleValueChange}
        onFocus={openCalendar}
        onKeyPress={onKeyPress}
      />
      {!disabled && clear && (
        <Button
          theme='btn--transparent_link'
          className={styles['calendar--btn-clear']}
          onClick={handleDelete}
          type='button'
        />
      )}
      <GxIcon
        className={styles['calendar--icon']}
        src={time ? ClockIcon : CalendarIcon}
        onClick={openCalendar}
      />
    </div>
  );
};

export default CalendarInput;
